<div class="typography" style="margin: 0; padding: 0">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    style="
      padding: 27px 32px;
      border-bottom: 1px solid rgba(222, 222, 222, 0.4);
    "
  >
    <h2 class="fc_DEDEDE">Selected EOI</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon style="color: #dedede">close</mat-icon>
    </button>
  </div>
  <div class="add-eoi" *ngIf="eoiDetail">
    <div>
      <div class="title-grid">
        <div fxLayout="row">
          <div class="eoi-no-title">EOI</div>
          <div class="eoi-no">{{eoiDetail.eoiNo}}</div>
          <span
            class="status"
            style="color: #ffaf13"
            *ngIf="eoiDetail.status == 'PENDING'"
            >● {{eoiDetail.status}}
          </span>
          <span
            class="status"
            style="color: #00e15a"
            *ngIf="eoiDetail.status == 'APPROVED'"
            >● {{eoiDetail.status}}
          </span>
          <span
            class="status"
            style="color: #ff5c00"
            *ngIf="eoiDetail.status == 'REJECTED'"
            >● {{eoiDetail.status}}
          </span>
          <span
            class="status"
            style="color: #ff5c00"
            *ngIf="eoiDetail.status == 'WITHDRAW'"
            >● {{eoiDetail.status}}
          </span>
          <span
            class="status"
            style="color: red"
            *ngIf="eoiDetail.status == 'REMOVED'"
            >● {{eoiDetail.status}}
          </span>
        </div>
        <div class="time" fxLayout="row">
          <div *ngIf="eoiDetail.status == 'PENDING'">
            Submitted on&nbsp;&nbsp;
          </div>
          <div *ngIf="eoiDetail.status != 'PENDING'">
            Processed on&nbsp;&nbsp;
          </div>
          <div *ngIf="eoiDetail.status == 'PENDING'">
            {{eoiDetail.createTime | date: 'h:mm:ss dd/MM/yyyy'}}
          </div>
          <div *ngIf="eoiDetail.status != 'PENDING'">
            {{eoiDetail.processTime | date: 'h:mm:ss dd/MM/yyyy'}}
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="value-grid">
        <div>
          <div class="label">Primary Buyer</div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
            "
          >
            <div>
              <div class="name">Full Name</div>
              <div class="txt">
                {{eoiDetail.buyer.firstName}}&nbsp;{{eoiDetail.buyer.middleName
                != 'undefined' ? eoiDetail.buyer.middleName :
                ''}}{{eoiDetail.buyer.lastName}}
              </div>
            </div>
            <div>
              <div class="name">Email Address</div>
              <div class="txt">{{eoiDetail.buyer.email}}</div>
            </div>
            <div>
              <div class="name">Phone Number</div>
              <div class="txt">{{eoiDetail.buyer.phoneNumber}}</div>
            </div>
            <div>
              <div class="name">Address</div>
              <div class="txt">
                {{eoiDetail.buyer.addressLine1}} ,{{eoiDetail.buyer.area}}
                {{eoiDetail.buyer.state}} {{eoiDetail.buyer.postCode}}
              </div>
            </div>
          </div>
        </div>
        <!-- <div>
          <div class="label">Payment Receipt</div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
            "
          >
            <div>
              <div *ngIf="eoiDetail.receipt" fxLayout="row">
                <div class="txt">{{eoiDetail.receipt.fileName}}</div>
                <mat-icon
                  style="font-size: 22px; color: #556ee6; cursor: pointer"
                  (click)="openReceiptFile(eoiDetail.receipt.fileName)"
                  >launch
                </mat-icon>
              </div>
            </div>
          </div>
        </div> -->
        <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 24px">
          <a
            *ngIf="eoiDetail.receipt"
            class="cursor_pointer"
            style="color: #556ee6; text-decoration: underline"
            (click)="openReceiptFile(eoiDetail.receipt.fileName)"
            >Payment Reciept</a
          >
          <a
            *ngIf="eoiDetail.eoiForm"
            class="cursor_pointer"
            style="color: #556ee6; text-decoration: underline"
            (click)="openEoiFile(eoiDetail.eoiForm.fileName)"
            >EOI Form</a
          >
          <!-- <div class="label">EOI Form</div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
            "
          >
            <div>
              <div *ngIf="eoiDetail.eoiForm" fxLayout="row">
                <div>{{eoiDetail.eoiForm.fileName}}</div>
                <mat-icon
                  style="font-size: 22px; color: #556ee6; cursor: pointer"
                  (click)="openEoiFile(eoiDetail.eoiForm.fileName)"
                  >launch
                </mat-icon>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <mat-divider  ></mat-divider>
      <div class="value-grid">
        <div>
          <ng-container *ngIf="eoiDetail.agent">
            <div class="label">Agent</div>
            <div
              class="agent-wrap"
              fxLayout="row"
              fxLayoutAlign="space-between"
            >
              <img
                style="
                  width: 48px;
                  height: 48px;
                  border-radius: 50%;
                  margin-top: 10px;
                "
                src="{{SERVER_URL}}images/user_{{eoiDetail.agent.id}}/{{eoiDetail.agent.headerUrl}}"
              />
              <div class="agent-item">
                <div class="name">Full Name</div>
                <div class="txt">
                  {{ eoiDetail.agent.firstName }}{{ eoiDetail.agent.lastName }}
                </div>
              </div>
              <div class="agent-item">
                <div class="name">Email Address</div>
                <div class="txt">{{agentEmail}}</div>
              </div>
              <!-- <div class="agent-item">
                <div class="name">Phone Number</div>
                <div class="txt">{{agentMobile}}</div>
              </div> -->
            </div>
            <div
              *ngIf="eoiDetail.status == 'REJECTED'||eoiDetail.status == 'REMOVED'"
            >
              <div
                fxLayout="row"
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 10px;
                "
              >
                <div style="padding: 0 20%" class="label">Reject reason</div>
                <div class="reason" *ngIf="!eoiDetail.rejectReason">
                  The application is removed because...
                </div>
                <div class="reason" *ngIf="eoiDetail.rejectReason">
                  {{ eoiDetail.rejectReason }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <mat-divider  *ngIf="eoiDetail.agency"></mat-divider>
      <div class="value-grid">
        <div>
          <ng-container *ngIf="eoiDetail.agency">
            <div class="label">Agency</div>
            <div
              class="agent-wrap"
              fxLayout="row"
              fxLayoutAlign="space-between"
            >
              <img
                style="
                  width: 48px;
                  height: 48px;
                  border-radius: 50%;
                  margin-top: 10px;
                "
                src="{{SERVER_URL}}images/company_{{eoiDetail.agency.id}}/{{eoiDetail.agency.logo.fileName}}"
              />
              <div class="agent-item">
                <div class="name">Full Name</div>
                <div class="txt">{{ eoiDetail.agency.name }}</div>
              </div>
              <div class="agent-item"></div>
              <!-- <div class="agent-item">
                <div class="name">Phone Number</div>
                <div class="txt">{{eoiDetail.agency.phoneNumber}}</div>
              </div> -->
            </div>
          </ng-container>
        </div>
      </div>

      <div
        fxLayout="row"
        fxLayoutGap="20px"
        style="
          display: flex;
          padding: 20px;
          justify-content: center;
          background-color: #161616;
        "
      >
        <button
          *ngIf="eoiDetail.status == 'PENDING'"
          mat-flat-button
          class="button_eoi button_reject"
          (click)="reject()"
        >
          <mat-icon>clear</mat-icon>
          Reject
        </button>
        <button
          *ngIf="eoiDetail.status == 'PENDING'"
          mat-flat-button
          class="button_eoi"
          (click)="approve()"
        >
          <mat-icon>done</mat-icon>
          Approve
        </button>

        <button
          *ngIf="eoiDetail.status == 'APPROVED'"
          mat-flat-button
          class="button_eoi"
          (click)="remove()"
        >
          <mat-icon>delete</mat-icon>
          Remove
        </button>
      </div>
    </div>
  </div>
</div>
